/* Vídeos ficam fora do repositório, no R2 (mesma estrutura de pastas
   de public/media). Em dev a variável fica vazia e serve de public/. */
const BASE = process.env.NEXT_PUBLIC_MEDIA_URL ?? "";

export const media = (path: string) => `${BASE}${path}`;
